import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import { HOME } from '../../../routes/paths';
import ListView from '../../components/views/listView';
import { MasterMessage } from '../../../masters/masterMessages';
import moment from 'moment';
import { Chip } from '@mui/material';
import ModalCaseCreation from './modalCaseCreation';
import dayjs from 'dayjs';
import Grid from '@mui/material/Grid';
import DatePickerField from '../../components/general/fields/datePickerField';
import CancelIcon from '@mui/icons-material/Cancel';
import { getGridStringOperators } from '@mui/x-data-grid';
import FieldSelect from '../../components/general/fields/fieldSelect';
import FieldText from '../../components/general/fields/fieldText';
import {
    asyncGetCasesCreations,
    asyncPostExportCaseCreation,
} from '../../../services/caseCreation.service';
import { b64toBlob } from '../../../shared/utils/files';
import { EXAMPLE_FILE_CASE_CREATION } from '../../../assets/files/file-example-case-creation';
import DownloadIcon from '@mui/icons-material/Download';
import { SwalCustomClass } from '../../components/general/toastSwal/swalCustomClass';
import Loading from '../../components/general/loading/loading';

export enum CaseCreationEnum {
    PENDING = 'PENDING',
    CREATED = 'CREATED',
    ERROR = 'ERROR',
    INPROG = 'INPROG',
}

const ListCaseCreation = () => {
    const navigate = useNavigate();
    const [rows, setRows] = useState<any>();
    const [lengthRows, setLengthRows] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(true);
    const [loadingPage, setLoadingPage] = useState<boolean>(false);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(20);
    const [open, setOpen] = useState<boolean>(false);
    const [saveLoad, setSaveLoad] = useState<boolean>(false);
    const [startDate, setStartDate] = useState<any>(null);
    const [endDate, setEndDate] = useState<any>(null);
    const [document, setDocument] = useState<string>('');
    const [status, setStatus] = useState<string>('');
    const filterOperators = getGridStringOperators().filter(({ value }) =>
        ['equals'].includes(value)
    );
    const { titleList, messageOkExport, messageErrorExport } =
        MasterMessage.caseCreation;

    const loadData = () => {
        const dateStart = startDate
            ? dayjs(startDate)
                .startOf('day')
                .add(5, 'h')
                .format('YYYY/MM/DD HH:mm:ss')
            : null;
        const dateEnd = endDate
            ? dayjs(endDate)
                .endOf('day')
                .add(5, 'h')
                .format('YYYY/MM/DD HH:mm:ss')
            : null;

        if (saveLoad && page !== 0) {
            setPage(0);
            setSaveLoad(false);
            return;
        } else if (saveLoad) setSaveLoad(false);

        if (loading || saveLoad) {
            asyncGetCasesCreations(
                page,
                pageSize,
                dateStart,
                dateEnd,
                document,
                status
            )
                .then((body: any) => {
                    if (body.items !== undefined) {
                        setRows(body.items.items);
                        setLengthRows(body.items.length);
                    }
                })
                .finally(() => setLoading(false));
        }
    };

    useEffect(() => {
        loadData();
    }, [
        page,
        pageSize,
        saveLoad,
        startDate,
        endDate,
        document,
        status,
        loading,
    ]);

    const paginator = (paginationModel: any) => {
        if (paginationModel.page !== page) {
            setPage(paginationModel.page);
            setLoading(true);
        } else if (paginationModel.pageSize !== pageSize) {
            setPageSize(paginationModel.pageSize);
            setLoading(true);
        }
    };

    const columns = [
        {
            field: 'document',
            headerName: 'Documento',
            minWidth: 120,
            flex: 1,
            filterOperators,
        },
        {
            field: 'globalInteractionId',
            headerName: 'Global id',
            minWidth: 120,
            flex: 1,
            filterOperators,
        },
        {
            field: 'attempts',
            headerName: 'Intentos',
            minWidth: 120,
            flex: 1,
        },
        {
            field: 'caseId',
            headerName: 'Número caso',
            minWidth: 120,
            flex: 1,
            filterOperators,
        },
        {
            field: 'created_at',
            headerName: 'Fecha de solicitud',
            minWidth: 120,
            flex: 1,
            type: 'date',
            filterable: false,
            valueFormatter: (params: any) =>
                params?.value !== null
                    ? moment(params?.value)
                        .subtract(5, 'h')
                        .format('DD/MM/YYYY HH:mm')
                    : null,
        },
        {
            field: 'creationDate',
            headerName: 'Fecha de creación',
            minWidth: 120,
            flex: 1,
            type: 'date',
            filterable: false,
            renderCell: (row: any) => {
                return row?.row?.updated_at &&
                    row?.row?.status === CaseCreationEnum.CREATED
                    ? moment(row?.row?.updated_at)
                        .subtract(5, 'h')
                        .format('DD/MM/YYYY HH:mm')
                    : null;
            },
        },
        {
            field: 'status',
            headerName: 'Estado',
            minWidth: 100,
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            filterOperators,
            renderCell: (row: any) => {
                if (row.row.status === CaseCreationEnum.PENDING) {
                    return (
                        <Chip
                            label="ABIERTO"
                            sx={{ ml: 1, fontSize: 11.5 }}
                            color="info"
                        />
                    );
                } else if (row.row.status === CaseCreationEnum.CREATED) {
                    return (
                        <Chip
                            label="CREADO"
                            sx={{ ml: 1, fontSize: 11.5 }}
                            color="success"
                        />
                    );
                } else if (row.row.status === CaseCreationEnum.INPROG) {
                    return (
                        <Chip
                            label="INPROG"
                            sx={{ ml: 1, fontSize: 11.5 }}
                            color="info"
                        />
                    );
                } else {
                    return (
                        <Chip
                            label="ERROR"
                            sx={{ ml: 1, fontSize: 11.5 }}
                            color="error"
                        />
                    );
                }
            },
        },
        {
            field: 'createdBy',
            headerName: 'Creado Por',
            minWidth: 120,
            flex: 1,
            filterable: false,
            valueFormatter: (params: any) =>
                params?.value.name + ' ' + params?.value.surname || '',
        },
    ];

    const validateStartDate = (value: any) => {
        setLoading(true);
        setStartDate(value);
        if (value && startDate) {
            setEndDate(null);
        }
    };

    const validateEndDate = (value: any) => {
        setLoading(true);
        setEndDate(value);
    };

    const validateStatus = (value: any) => {
        setLoading(true);
        setStatus(value);
    };

    const validateDocument = (value: any) => {
        setLoading(true);
        setDocument(value);
    };

    const clearFilters = () => {
        setStartDate(null);
        setEndDate(null);
        setStatus('');
        setLoading(true);
    };

    const validateFilters = (filter: any) => {
        if (filter) {
            switch (filter.field) {
                case 'document':
                    return setDocument(filter.value);
            }
        } else {
            setDocument('');
        }
        setLoading(true);
    };

    const dataStatus = [
        {
            id: CaseCreationEnum.PENDING,
            name: 'Abierto',
        },
        {
            id: CaseCreationEnum.CREATED,
            name: 'Creado',
        },
        {
            id: CaseCreationEnum.ERROR,
            name: 'Error',
        },
        {
            id: CaseCreationEnum.INPROG,
            name: 'En proceso',
        },
    ];

    const handleDownloadFile = () => {
        const blob = b64toBlob(
            EXAMPLE_FILE_CASE_CREATION,
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        );
        const blobUrl = URL.createObjectURL(blob);
        window.location = blobUrl as any;
    };

    const handleDownloadFilExport = async () => {
        setLoadingPage(true);
        const body: any = await asyncPostExportCaseCreation({
            startDate,
            endDate,
            status,
            document,
        });
        if (body.items !== undefined) {
            window.open(body.items?.url);
            setLoadingPage(false);
            SwalCustomClass.fire({
                text: messageOkExport,
                icon: 'success',
                iconColor: '#1d1d1d',
            });
        } else {
            setLoadingPage(false);
            SwalCustomClass.fire({
                text: messageErrorExport,
                icon: 'error',
                iconColor: '#1d1d1d',
            });
        }
    };

    return loadingPage ? (
        <Loading />
    ) : (
        <>
            <ListView
                title={titleList}
                titleButtonAdd={'Importar'}
                startIconButtonAdd={<FileUploadIcon color="secondary" />}
                onClickAdd={() => setOpen(true)}
                onClickBack={() => navigate(HOME)}
                enabledButtonGeneral={true}
                titleButtonGeneral={'Descargar'}
                startIconButtonGeneral={<DownloadIcon color="secondary" />}
                onClickButtonGeneral={() => handleDownloadFilExport()}
                enabledSecondButtonGeneral={Boolean(
                    startDate !== null || status !== ''
                )}
                titleSecondButtonGeneral={'Limpiar Filtros'}
                startIconSecondButtonGeneral={<CancelIcon color="secondary" />}
                onClickSecondButtonGeneral={() => clearFilters()}
                columns={columns}
                rows={rows}
                rowCount={lengthRows}
                disableRow={true}
                loading={loading}
                onSetPage={(paginationModel: any) => paginator(paginationModel)}
                filterAvanced={true}
                onFilterAvanced={(filter: any) => validateFilters(filter)}
                enabledSearch={true}
                searchField={
                    <>
                        <Grid
                            container
                            spacing={{ xs: 1.5 }}
                            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                        >
                            <Grid item xs={12} md={3}>
                                <DatePickerField
                                    label="Fecha inicio"
                                    name="startDate"
                                    size="small"
                                    maxDate={dayjs()}
                                    disabled={startDate}
                                    value={startDate}
                                    onChange={(value) =>
                                        validateStartDate(value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <DatePickerField
                                    label="Fecha fin"
                                    name="endDate"
                                    size="small"
                                    minDate={dayjs(startDate)}
                                    maxDate={dayjs()}
                                    disabled={!startDate || endDate}
                                    value={endDate}
                                    onChange={(value) => validateEndDate(value)}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FieldSelect
                                    data={dataStatus}
                                    label="Estado"
                                    name="status"
                                    size="small"
                                    value={status}
                                    onChange={(value: any) =>
                                        validateStatus(value?.target?.value)
                                    }
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <FieldText
                                    label="Documento"
                                    name="document"
                                    size="small"
                                    value={document}
                                    onChange={(value: any) =>
                                        validateDocument(value?.target?.value)
                                    }
                                />
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            mt={1}
                            display="flex"
                            justifyContent="space-between"
                        >
                            <a onClick={handleDownloadFile}>
                                Descarga ejemplo de la base
                            </a>
                            <a onClick={() => setLoading(true)}>
                                Recargar lista
                            </a>
                        </Grid>
                    </>
                }
            />
            {open && (
                <ModalCaseCreation
                    open={open}
                    onClose={(value: boolean) => setOpen(value)}
                    saveLoad={(value: boolean) => setSaveLoad(value)}
                />
            )}
        </>
    );
};

export default ListCaseCreation;
